export default __webpack_public_path__ + "static/bundle-box-01-455c57207da53f8718bb74d7c22b68aa.png";